import cn from 'classnames';
import { useCallback } from 'preact/hooks';
import {
  buildProductUrl,
  productTypeToUrlCompatibleString,
  type Product
} from '@/domain/Product.ts';
import SkeletonText from '@/widgets/components/controls/Skeleton/SkeletonText.tsx';
import styles from './ProductNameSection.module.scss';
import useWidgetOptions from '@/widgets/hooks/useWidgetOptions';
import type { Options } from '@/widgets/ProductList/config/index.ts';
import useRoute from '@/widgets/hooks/useRoute';

export type ProductNameSectionProps = {
  product: Product;
  class?: string;
};

export default function ProductNameSection({
  class: className,
  product
}: ProductNameSectionProps) {
  const { enableProductCardQuickView } = useWidgetOptions<Options>();
  const { market, locale } = useRoute();
  const { slug, name } = product;

  const url = buildProductUrl(
    market,
    locale,
    productTypeToUrlCompatibleString[product.type],
    product.technologies[0],
    slug
  );

  const onClick = useCallback(
    (event: MouseEvent) => {
      if (enableProductCardQuickView) event?.preventDefault();
    },
    [enableProductCardQuickView]
  );

  return (
    <h3 class={styles.label}>
      <a
        href={url}
        class={cn(styles.link, className)}
        title={name}
        onClick={onClick}
      >
        {name}
      </a>
    </h3>
  );
}

ProductNameSection.Skeleton = function Skeleton() {
  return (
    <div class={styles.skeleton}>
      <SkeletonText />
    </div>
  );
};
